import { render, staticRenderFns } from "./OtpModal.vue?vue&type=template&id=5037814c"
import script from "./OtpModal.vue?vue&type=script&lang=ts"
export * from "./OtpModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports